import React, { ChangeEvent, FC } from 'react';
import Pagination from '@mui/material/Pagination';

interface PaginacaoProps {
  totalRegistros: number;
  paginaAtual: number;
  porPagina: number;
  aoMudarPagina:(event: React.ChangeEvent<unknown>, value: number) => void;
}

const Paginacao: FC<PaginacaoProps> = ({
  totalRegistros,
  paginaAtual,
  porPagina,
  aoMudarPagina
}) => {
  
  const totalPaginas = Math.ceil(totalRegistros / porPagina);

  const handleChange = (event: ChangeEvent<unknown>, novaPagina: number) => {
    aoMudarPagina(event, novaPagina);
  };

  return (
    <Pagination
      count={totalPaginas}
      page={paginaAtual}
      onChange={handleChange}
    />
  );
};

export default Paginacao;
